module.exports = __webpack_public_path__ + "static/media/logo-successfully-submitted-form.643cc04b.svg";